import { useMemo } from 'react';

import { Icon } from '@/components/Icon';

import { mergeClassNames } from '@/utils';

import styles from './SensorCard.module.css';

interface SensorCardNotCalibratedProps {
  batteryLevel: number;
}

export const SensorCardNotCalibrated = ({ batteryLevel }: SensorCardNotCalibratedProps) => {
  const batteryZone = useMemo(() => {
    if (batteryLevel > 50) {
      return 'high';
    }

    if (batteryLevel > 30) {
      return 'medium';
    }

    return 'low';
  }, [batteryLevel]);

  return (
    <div className={mergeClassNames(styles.batteryIndicator, styles[batteryZone])}>
      <Icon
        name={
          {
            high: 'batteryFull' as const,
            medium: 'batteryWarning' as const,
            low: 'batteryCritical' as const,
          }[batteryZone]
        }
      />
      {batteryLevel}%
    </div>
  );
};
